export function set<T, U extends keyof T>(obj: T, key: U, value: T[U]): T {
  return { ...obj, [key]: value };
}

export function setm<T>(obj: T, values: Partial<T>): T {
  return { ...obj, ...values };
}

export function seta<T extends Array<U>, U>(
  arr: T,
  idx: number,
  value: T[number]
): Array<U> {
  return [...arr.slice(0, idx), value, ...arr.slice(idx + 1)];
}

export function upd<T, U extends keyof T /*T extends any ? keyof T : never*/>(
  obj: T,
  key: U,
  updater: (currentValue: T[U]) => T[U]
): T {
  return { ...obj, [key]: updater(obj[key]) };
}

export function updm<T>(obj: T, updater: (currentValue: T) => Partial<T>): T {
  return { ...obj, ...updater(obj) };
}

export function rmv<T, U extends keyof T>(obj: T, key: U): Omit<T, U> {
  const { [key]: _, ...rest } = obj;
  return rest;
}

export function rmva<T extends Array<U>, U>(arr: T, idx: number): Array<U> {
  return [...arr.slice(0, idx), ...arr.slice(idx + 1)];
}
